import { Link, useBoolean } from "@chakra-ui/react";

interface FooterButtonProps {
	path: string;
	label: string;
	isExternal?: boolean;
}

export const FooterButton = (props: FooterButtonProps) => {
	const { path, label, isExternal = false } = props;

	const [isFocused, setIsFocused] = useBoolean();

	const formattedLabel = label.toUpperCase();
	const isDark =
		formattedLabel === "BACK TO TOP" || formattedLabel === "MES CHERIES";
	const showDecoration = isFocused && !isExternal && !isDark;

	return (
		<Link
			href={path}
			fontSize="sm"
			w="fit-content"
			isExternal={isExternal}
			onMouseEnter={setIsFocused.on}
			onMouseLeave={setIsFocused.off}
			_hover={{
				textDecoration: "none",
				color: isDark ? "brand.mid" : "brand.contrast",
			}}
		>
			{showDecoration && "✦ "}
			{formattedLabel}
			{showDecoration && " ✦"}
		</Link>
	);
};
